import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import useLenis from "./hooks/useLenis";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Services from "./components/Services";
import FriseurPromo from "./components/FriseurPromo";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FriseurPage from "./pages/Friseur";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";

function SmoothScrollShell({ children }) {
  useLenis();
  return children;
}

function HomePage() {
  return (
    <div className="App relative" data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <Services />
        <FriseurPromo />
        <About />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScrollShell>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/friseur" element={<FriseurPage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
          </Routes>
        </SmoothScrollShell>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
